<div class="new-shipper-modal modal-el">
  <div class="modal-info-box shipper-info">
    <div class="title" *ngIf="!shipperForEdit">Add new shipper</div>
    <div class="title" *ngIf="shipperForEdit">Update shipper</div>
    <div class="shipper-form">
      <form [formGroup]="shipperForm">
        <div class="double-controls">
          <div class="form-control">
            <label for="shipperName">Shipper name *</label>
            <input
              type="text"
              id="shipperName"
              placeholder="Enter shipper name"
              formControlName="name"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.name?.touched &&
                  shipperForm.controls.name?.hasError('required')
                "
                >Shipper name is required</span
              >
              <span
                *ngIf="
                  shipperForm.controls.name?.touched &&
                  shipperForm.controls.name?.hasError('pattern')
                "
                >Incorrect shipper name</span
              >
            </div>
          </div>
          <div class="form-control">
            <label>Country *</label>
            <mat-form-field appearance="outline">
              <mat-select
                disableRipple
                hideSingleSelectionIndicator
                formControlName="countryId"
              >
                <mat-option>
                  <ngx-mat-select-search
                    placeholderLabel="Search..."
                    [formControl]="searchCountries"
                    noEntriesFoundLabel="No countries found"
                    [clearSearchInput]="false"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let country of countries"
                  [value]="country.id"
                  >{{ country.name }}</mat-option
                >
              </mat-select>
              <mat-icon matSuffix class="select-icon-replacement"
                >expand_more</mat-icon
              >
            </mat-form-field>
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.countryId?.touched &&
                  shipperForm.controls.countryId?.hasError('required')
                "
                >Country is required</span
              >
            </div>
          </div>
        </div>
        <div class="double-controls">
          <div class="form-control">
            <label for="city">City *</label>
            <input
              type="text"
              id="city"
              placeholder="Enter city"
              formControlName="city"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.city?.touched &&
                  shipperForm.controls.city?.hasError('required')
                "
                >City is required</span
              >
              <span
                *ngIf="
                  shipperForm.controls.city?.touched &&
                  shipperForm.controls.city?.hasError('pattern')
                "
                >Incorrect city name</span
              >
            </div>
          </div>
          <div class="form-control">
            <label for="address">Address *</label>
            <input
              type="text"
              id="address"
              placeholder="Enter address"
              formControlName="address"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.address?.touched &&
                  shipperForm.controls.address?.hasError('required')
                "
                >Address is required</span
              >
              <span
                *ngIf="
                  shipperForm.controls.address?.touched &&
                  shipperForm.controls.address?.hasError('pattern')
                "
                >Incorrect address</span
              >
            </div>
          </div>
        </div>
        <div class="double-controls">
          <div class="form-control">
            <label for="province">Province or State</label>
            <input
              type="text"
              id="province"
              placeholder="Enter province or state"
              formControlName="province"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.province?.touched &&
                  shipperForm.controls.province?.hasError('required')
                "
                >Province is required</span
              >
              <span
                *ngIf="
                  shipperForm.controls.province?.touched &&
                  shipperForm.controls.province?.hasError('pattern')
                "
                >Incorrect province</span
              >
            </div>
          </div>
          <div class="form-control">
            <label for="zip">Code (Postal/Zip) *</label>
            <input
              type="text"
              id="zip"
              placeholder="Enter code (postal/zip)"
              formControlName="zipCode"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.zipCode?.touched &&
                  shipperForm.controls.zipCode?.hasError('required')
                "
                >Code is required</span
              >
              <span
                *ngIf="
                  shipperForm.controls.zipCode?.touched &&
                  shipperForm.controls.zipCode?.hasError('pattern')
                "
                >Incorrect code</span
              >
            </div>
          </div>
        </div>
        <div class="lines-box">
          <div class="double-controls">
            <div class="form-control">
              <label for="line_one">Line 1</label>
              <input type="text" id="line_one" formControlName="line1" />
              <div class="field-error">
                <span
                  *ngIf="
                    shipperForm.controls.line1?.touched &&
                    shipperForm.controls.line1?.hasError('pattern')
                  "
                  >Use only letters, symbols and numbers</span
                >
              </div>
            </div>
            <div class="form-control">
              <label for="line_two">Line 2</label>
              <input type="text" id="line_two" formControlName="line2" />
              <div class="field-error">
                <span
                  *ngIf="
                    shipperForm.controls.line2?.touched &&
                    shipperForm.controls.line2?.hasError('pattern')
                  "
                  >Use only letters, symbols and numbers</span
                >
              </div>
            </div>
          </div>
          <div class="double-controls">
            <div class="form-control">
              <label for="line_three">Line 3</label>
              <input type="text" id="line_three" formControlName="line3" />
              <div class="field-error">
                <span
                  *ngIf="
                    shipperForm.controls.line3?.touched &&
                    shipperForm.controls.line3?.hasError('pattern')
                  "
                  >Use only letters, symbols and numbers</span
                >
              </div>
            </div>
            <div class="form-control">
              <label for="line_four">Line 4</label>
              <input type="text" id="line_four" formControlName="line4" />
              <div class="field-error">
                <span
                  *ngIf="
                    shipperForm.controls.line4?.touched &&
                    shipperForm.controls.line4?.hasError('pattern')
                  "
                  >Use only letters, symbols and numbers</span
                >
              </div>
            </div>
          </div>
          <div class="double-controls">
            <div class="form-control">
              <label for="line_five">Line 5</label>
              <input type="text" id="line_five" formControlName="line5" />
              <div class="field-error">
                <span
                  *ngIf="
                    shipperForm.controls.line5?.touched &&
                    shipperForm.controls.line5?.hasError('pattern')
                  "
                  >Use only letters, symbols and numbers</span
                >
              </div>
            </div>
            <div class="form-control">
              <label for="line_six">Line 6</label>
              <input type="text" id="line_six" formControlName="line6" />
              <div class="field-error">
                <span
                  *ngIf="
                    shipperForm.controls.line6?.touched &&
                    shipperForm.controls.line6?.hasError('pattern')
                  "
                  >Use only letters, symbols and numbers</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="person-title">Key Person</div>
        <div class="double-controls">
          <div class="form-control">
            <label for="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              placeholder="Enter first name"
              formControlName="firstName"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.firstName?.touched &&
                  shipperForm.controls.firstName?.hasError('pattern')
                "
                >Incorrect name</span
              >
            </div>
          </div>
          <div class="form-control">
            <label for="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              placeholder="Enter last name"
              formControlName="lastName"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.lastName?.touched &&
                  shipperForm.controls.lastName?.hasError('pattern')
                "
                >Incorrect last name</span
              >
            </div>
          </div>
        </div>
        <div class="double-controls">
          <div class="form-control">
            <label for="email">Email</label>
            <input
              type="text"
              id="email"
              placeholder="Enter email address"
              formControlName="email"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.email?.touched &&
                  shipperForm.controls.email?.hasError('pattern')
                "
                >Incorrect email</span
              >
            </div>
          </div>
          <div class="form-control">
            <label for="phone">Phone</label>
            <input
              type="text"
              id="phone"
              placeholder="Enter phone number"
              formControlName="phone"
              (input)="validateTel()"
            />
            <div class="field-error">
              <span
                *ngIf="
                  shipperForm.controls.phone?.touched &&
                  shipperForm.controls.phone?.hasError('pattern')
                "
                >Invalid number 111</span
              >
              <span *ngIf="isTelCustomError">{{ telError }}</span>
            </div>
          </div>
        </div>
      </form>
      <div class="form-actions">
        <button
          mat-button
          class="delete-btn"
          *ngIf="shipperForEdit"
          (click)="deleteShipper()"
        >
          Delete Shipper
        </button>
        <button mat-stroked-button class="cancel-btn" (click)="closeModal()">
          Cancel
        </button>
        <button
          mat-button
          class="action-btn"
          [disabled]="shipperForm.invalid || isTelCustomError"
          (click)="addNewShipper()"
        >
          <span *ngIf="!shipperForEdit">Add Shipper</span>
          <span *ngIf="shipperForEdit">Update Shipper</span>
        </button>
      </div>
    </div>
  </div>
</div>
